import { render, staticRenderFns } from "./BlogSection.vue?vue&type=template&id=3a2ef2f0&scoped=true"
import script from "./BlogSection.vue?vue&type=script&lang=js"
export * from "./BlogSection.vue?vue&type=script&lang=js"
import style0 from "./BlogSection.vue?vue&type=style&index=0&id=3a2ef2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ef2f0",
  null
  
)

export default component.exports